module.exports = __webpack_public_path__ + "static/img/img4.397bc48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slideVerify/assets/img4.jpg
// module id = 355y
// module chunks = 1